import React, { useEffect, useRef, useState } from "react";
import "./Prie.css";
import { Box, Button, Modal, Stack } from "@mui/material";
// import upload from "../../../Assets"
import upload from "../../../Assets/uploadfile.svg";
import print from "../../../Assets/print.svg";
import download from "../../../Assets/downloadcv.png";
import Loader from "../../Loader/Loader";
import { APIDataUrl, APITokenUrl, GetUserId } from "../../../Utils/Utils";
import axios from "axios";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import PrieDirectPath from "./PrieDirectPath";
import PrieIndirectPath from "./PrieIndirectPath";
import { APP_CONFIG } from "../../../Utils/env";
const Prie = ({
  dataForInformation,
  isDownloading,
  
  
}) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "600",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 2,
    borderRadius: "8px",
  };
  const [selectedValue, setSelectedValue] = useState("direct");
  const [loading, setLoading] = useState(false);
  const [crieData, setCrieData] = useState([]);
  const [crieDataInitial, setCrieDataInitial] = useState([]);
  const [inDirectSummary, setInDirectSummary] = useState();
  const [indirectCount, setIndirectCount] = useState(0);
  const [baseIndirectCount, setBaseIndirectCount] = useState(0);
  const [crieSrcList, setCrieSrcList] = useState([]);
  const [associateList, setAssociateList] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [disabledIndirect, setDisabledIndirect] = useState("");
  const [modalOpenRefresh, setModalOpenRefresh] = useState(false);
  const [crieIndirectData, setCrieIndirectData] = useState([]);
  const [crieStrengthList, setCrieStrengthList] = useState();
  const [crieIndirectAssociateList, setCrieIndirectAssociateList] =
    useState([]);
  const [indirectAssociateList, setIndirectAssociateList] = useState([]);

  const [strengthList, setStrengthList] = useState([]);
  const handleRadioChange = (event) => {
    setSelectedValue(event.target.value);
  };
  const handleModalClose = () => {
    setModalOpen(false);
  };
  const getCrieIndirectdata = () => {
    setLoading(true);
    const data = {
      // src_id: [process.env.REACT_APP_JOI_JO_ID],
      src_id: [APP_CONFIG.JOI_JO_ID],
      target_id: [dataForInformation?.person_id?.toString()],
    };
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      data: data,
      url: `${APIDataUrl()}/v1/prie_get_initial_indirect_dropdown`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          let data = e?.data?.doc;
          setDisabledIndirect(
            e?.data?.indirect_request || e?.data?.doc?.indirect_request,
          );
          setInDirectSummary(data?.summary);
          setIndirectCount(data?.summary?.number_of_path);
          setBaseIndirectCount(data?.summary?.number_of_path);
          setIndirectAssociateList(data?.summary?.source_nodes);
          setCrieIndirectAssociateList(data?.summary?.source_nodes);
          setStrengthList(
            data?.summary?.strengths?.map((item) => ({
              name: item,
              joi_id: item,
            })),
          );
          setCrieStrengthList(
            data?.summary?.strengths?.map((item) => ({
              name: item,
              joi_id: item,
            })),
          );
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const getCriedata = () => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/prie_get_direct_path?source_id=${
        // process.env.REACT_APP_JOI_JO_ID
        APP_CONFIG.JOI_JO_ID
      }&destination_id=${dataForInformation?.person_id}`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          let data = e?.data;
          setCrieData(data?.data);
          setCrieDataInitial(data?.data);
          const dataJo = data?.src_list?.map((item) => ({
            name: item[0],
            value: item[1],
          }));
          setAssociateList(dataJo);
          setCrieSrcList(dataJo);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getCrieIndirectdata();
    getCriedata();
  }, [dataForInformation]);

  const handleInterestRequest = () => {
    setLoading(true);
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 60);
    const trackUntil = currentDate.toISOString().split("T")[0];
    const data = {
      request_type: "prie",
      external_id: null,
      first_name: null,
      last_name: null,
      position_title: null,
      organization_name: null,
      linkedin: null,
      organization_website: null,
      person_id: null,
      org_id: null,
      category: "person",
      track_until: trackUntil,
      // source_id: process.env.REACT_APP_JOI_JO_ID,
      source_id: APP_CONFIG.JOI_JO_ID,
      source_name: "Jobsohio",
      target_id: String(dataForInformation?.person_id),
      target_name: dataForInformation?.name,
      source: null,
      user_approval: null,
      user_id: Number(GetUserId()),
      user_email: null,
    };
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      data: data,
      url: `${APIDataUrl()}/v1/interest_request`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          setModalOpen(false);
          setModalOpenRefresh(false);
          getCrieIndirectdata();
          toast.success(e?.data?.message);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const calculateDaysDifference = (generatedDate) => {
    const generated = new Date(generatedDate);
    const currentDate = new Date();
    const differenceInMs = currentDate - generated;
    const differenceInDays = Math.floor(differenceInMs / (1000 * 60 * 60 * 24));
    return differenceInDays;
  };
  return (
    <>
      {loading ? <Loader /> : null}
      <div
        className={
          isDownloading
            ? "DecisionMaker-table-main-pdf crit_out"
            : "DecisionMaker-table-main crit_out"
        }
      >
        <div className="crie-cont-main-crie">
          <div className="crie-cont">
            <p className="company-head-crie">
              Prospect and Relationship Intelligence Explorer (PRIE)
            </p>
          </div>
          <div>
            <p className="urilize-subhead-crie">
              Utilize the filters below to quickly find direct paths from
              Orbit to{" "}
              <span style={{ textTransform: "capitalize" }}>
                {dataForInformation?.name}
              </span>
              .
            </p>
            <p className="directpath-crie">
              {crieData?.length} Direct Paths{" "}
              {(disabledIndirect === "processing" && indirectCount) ||
              (disabledIndirect === "refresh" && indirectCount)
                ? `| ${indirectCount || 0} Indirect paths`
                : null}{" "}
              found as of{" "}
              {inDirectSummary?.generated_date
                ? moment(inDirectSummary?.generated_date).format("M.DD.YY")
                : moment(inDirectSummary?.generated_date).format("M.DD.YY")}
            </p>
          </div>
        </div>
        {selectedValue == "direct" ? (
          <PrieDirectPath
            dataForInformation={dataForInformation}
            crieData={crieData}
            setCrieData={setCrieData}
            crieDataInitial={crieDataInitial}
            crieSrcList={crieSrcList}
            associateList={associateList}
            setAssociateList={setAssociateList}
            setModalOpen={setModalOpen}
            setLoading={setLoading}
            handleRadioChange={handleRadioChange}
            selectedValue={selectedValue}
            disabledIndirect={disabledIndirect}
            setModalOpenRefresh={setModalOpenRefresh}
          />
        ) : (
          <PrieIndirectPath
            isDownloading={isDownloading}
            dataForInformation={dataForInformation}
            crieData={crieIndirectData}
            setCrieData={setCrieIndirectData}
            // crieDstList={crieorganizationIndirectAssociateList}
            crieSrcList={crieIndirectAssociateList}
            // crieMiddleList={criemiddleAssociateList}
            associateList={indirectAssociateList}
            setAssociateList={setIndirectAssociateList}
            // organizationAssociateList={organizationIndirectAssociateList}
            // setOrganizationAssociateList={setOrganizationIndirectAssociateList}
            strengthList={strengthList}
            setStrengthList={setStrengthList}
            crieStrengthList={crieStrengthList}
            setLoading={setLoading}
            handleRadioChange={handleRadioChange}
            // middleAssociateList={middleAssociateList}
            // setMiddleAssociateList={setMiddleAssociateList}
            selectedValue={selectedValue}
            disabledIndirect={disabledIndirect}
            setIndirectCount={setIndirectCount}
            inDirectSummary={inDirectSummary}
            getCrieIndirectdata={getCrieIndirectdata}
            setModalOpenRefresh={setModalOpenRefresh}
            baseIndirectCount={baseIndirectCount}
          />
        )}
      </div>
      <Modal
        open={modalOpen}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="vrufyerv">
          <Box sx={style}>
            <div className="modal-head-heading-crossicon">
              <div className="crie-cont crie_direct">
                Prospect and Relationship Intelligence Explorer (PRIE)
              </div>
            </div>
            <div className="crie-head crie-cont">
              {" "}
              We will locate all in-direct connection paths and notify you when
              ready{" "}
            </div>
            <Stack>
              <div className="button-cancel-save-modal">
                <Button
                  variant="type"
                  className="cancel-button-modal"
                  onClick={() => handleModalClose()}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleInterestRequest}
                  variant="type"
                  className="save-button-modal"
                >
                  Submit
                </Button>
              </div>
            </Stack>
          </Box>
        </div>
      </Modal>
      <Modal
        open={modalOpenRefresh}
        onClose={() => setModalOpenRefresh(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="vrufyerv">
          <Box sx={style}>
            <div className="modal-head-heading-crossicon">
              <div className="crie-cont crie_direct">
                Prospect and Relationship Intelligence Explorer (PRIE)
              </div>
            </div>
            <div className="crie-head crie-cont">
              {calculateDaysDifference(inDirectSummary?.generated_date) < 30
                ? "The paths you requested were generated less than 30 days ago. Generating new ones will take approximately one day and may not result in new paths or additional information. Do you want to proceed with this request?"
                : "Are you sure you want to refresh this request?"}
            </div>
            <Stack>
              <div className="button-cancel-save-modal">
                <Button
                  variant="type"
                  className="cancel-button-modal"
                  onClick={() => setModalOpenRefresh(false)}
                >
                  Cancel
                </Button>
                <Button
                  variant="type"
                  className="save-button-modal"
                  onClick={handleInterestRequest}
                >
                  Yes
                </Button>
              </div>
            </Stack>
          </Box>
        </div>
      </Modal>
    </>
  );
};
export default Prie;
